import { appSelect } from "@entities/app";
import { authInfoSelect } from "@entities/auth";
import { RadialBarChart } from "@pages/dashboard/plugins/components/charts";
import { API_DATE_FORMAT } from "@utils/const";
import dayjs from "dayjs";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import StatusSelector from "../components/StatusSelector";
import * as S from "./style.styled";

interface ICategory {
  borderColor?: string;
  color?: string;
  id: number;
  name_invented: string;
  shop_id?: number;
  state?: any;
}
const initial_category = {
  id: 0,
  name_invented: "Все категории",
};

export function Plag5() {
  const { shop } = useSelector(authInfoSelect);
  const { from, to } = useSelector(appSelect).dateRange;

  const [data, setData] = useState<any[]>([]);
  const [categories, setCategories] = useState<ICategory[]>([]);
  const [selectGroup, setSelectGroup] = useState<ICategory>(initial_category);

  const colors = [
    "#DD1A6A",
    "#FBB500",
    "#2B1ECA",
    "#BF6DFF",
    "#A7388E",
    "#6B00F3",
  ];

  const urlForRemains = useMemo(() => {
    if (!shop?.id) return null;

    const startDate = from
      ? dayjs(from, API_DATE_FORMAT).format(API_DATE_FORMAT)
      : "2024-01-01";
    const endDate = to
      ? dayjs(to, API_DATE_FORMAT).format(API_DATE_FORMAT)
      : "2024-11-01";

    const categoryParam =
      selectGroup && selectGroup.id !== 0
        ? `&category_id=${selectGroup.id}`
        : "";

    return `${process.env.REACT_APP_API_URL}/shops/${shop.id}/menu/top/totals?from=${startDate}&to=${endDate}&limit=6${categoryParam}`;
  }, [shop, from, to, selectGroup]);

  useEffect(() => {
    if (!urlForRemains) return;

    fetch(urlForRemains, {
      headers: {
        accept: "application/json",
        Authorization: `${localStorage.getItem("accessToken")}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((dataFetch) => {
        if (Array.isArray(dataFetch)) setData(dataFetch);
        else setData([]);
      })
      .catch(() => setData([]));
  }, [urlForRemains]);

  useEffect(() => {
    if (!shop?.id) return;

    const urlForCategories = `${process.env.REACT_APP_API_URL}/shops/${shop.id}/inventedCategory`;

    fetch(urlForCategories, {
      headers: {
        accept: "application/json",
        Authorization: `${localStorage.getItem("accessToken")}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((rest) => {
        if (Array.isArray(rest[0])) {
          setCategories([initial_category, ...rest[0]]);
        } else {
          setCategories([initial_category]);
        }
      })
      .catch(() => setCategories([initial_category]));
  }, [shop]);

  useEffect(() => {
    if (categories.length > 0) setSelectGroup(categories[0]);
  }, [categories]);

  return (
    <S.Plag6Wrap>
      <S.HeaderWrap>
        <S.Header>Популярные товары</S.Header>
        {categories && (
          <StatusSelector
            record={categories}
            setSelect={setSelectGroup}
            select={selectGroup}
          />
        )}
      </S.HeaderWrap>
      <S.PluginsWrap>
        {data.map((i, ind) => {
          const { name } = i;

          return (
            <S.RadialWrap key={`radialmap-${ind}`}>
              <RadialBarChart
                percentage={i.percent}
                colorDut={colors[ind]}
                text={i.name}
                add={i.count}
              />{" "}
              <S.StyledName>{name.substring(0, 20)}</S.StyledName>
            </S.RadialWrap>
          );
        })}
      </S.PluginsWrap>
    </S.Plag6Wrap>
  );
}
